import React from "react";
import MainPage from "./Components/MainPage";
function App() {
  return <MainPage />;
}

export default App;
